export const leaveData = [
    {
      key: "1",
      leaveType: "Medical Leave",
      leaveDate: "05 Mar 2025 - 09 Mar 2025",
      noOfDays: "5",
      appliedOn: "05 Mar 2025",
      status: "Approved"
    },
    {
      key: "2",
      leaveType: "Casual Leave",
      leaveDate: "07 Mar 2025 - 07 Mar 2025",
      noOfDays: "1",
      appliedOn: "07 Mar 2025",
      status: "Approved"
    },
    {
      key: "3",
      leaveType: "Special Leave",
      leaveDate: "09 Mar 2025 - 09 Mar 2025",
      noOfDays: "1",
      appliedOn: "09 Mar 2025",
      status: "Pending"
    },
    {
      key: "4",
      leaveType: "Casual Leave",
      leaveDate: "08 Mar 2025 - 08 Mar 2025",
      noOfDays: "1",
      appliedOn: "04 Mar 2025",
      status: "Approved"
    },
    {
      key: "5",
      leaveType: "Medical Leave",
      leaveDate: "08 Mar 2025 - 11 Mar 2025",
      noOfDays: "4",
      appliedOn: "08 Mar 2025",
      status: "Pending"
    },
    {
      key: "6",
      leaveType: "Casual Leave",
      leaveDate: "20 Mar 2025 - 20 Mar 2025",
      noOfDays: "1",
      appliedOn: "19 Mar 2025",
      status: "Pending"
    }
  ];
  